export const suppressNextClick = (windowMs = 300) => {
  if (typeof window === "undefined") return;
  const handler = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  };
  window.addEventListener("click", handler, { capture: true, once: true });
  window.setTimeout(() => {
    window.removeEventListener("click", handler, { capture: true });
  }, windowMs);
};
